import React from 'react';
import styles from './index.module.less';
import PropTypes from 'prop-types';
import {getFileUrl} from '@/page/util/appUrlUtils';

export default function FileCard({title, url, isFile = true, docShare = []}) {
    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <div>
                    <a href={url} className={styles.title} target="_blank">
                        {title}
                    </a>
                </div>
                <div className={styles.icon}>
                    <img
                        src={
                            isFile
                                ? require('@/asset/file.png').default
                                : require('@/asset/voice.png').default
                        }
                    />
                </div>
            </div>
            {!isFile &&
                docShare.length > 0 &&
                docShare.map((item, i) => (
                    <div className={styles.file} key={i}>
                        <a
                            href={getFileUrl(
                                item.voipDocShare.attachment,
                                item.voipDocShare.attachmentext
                            )}
                            target="_blank"
                        >
                            {item.voipDocShare.filename}
                        </a>
                    </div>
                ))}
        </div>
    );
}

FileCard.propTypes = {
    title: PropTypes.string,
    url: PropTypes.string,
    isFile: PropTypes.bool,
    docShare: PropTypes.array,
};
